import {useCallback, useState} from "react";
import {useSiren} from "../SirenContext";
import {platformAPI} from "../../../api/axiosConfig";
import {useNavigateWithClientID} from "./useNavigateWithClientID";

export function useCreateContactGroup() {
    const [name, setName] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const {navigateWithClientID} = useNavigateWithClientID();
    const {clientID, setToast} = useSiren();

    const submit = useCallback(async () => {
        setIsLoading(true);
        try {
            await platformAPI.post("api/contact-groups", {name, clientID});
            setToast("Contact group created", "success");
            navigateWithClientID("/siren/groups");
        } finally {
            setIsLoading(false);
        }
    }, [name, clientID]);

    return {name, setName, isLoading, submit};
}
